import { Image } from "antd";
import { useContext } from "react";
import { useLocation } from "react-router-dom";
import elementalSvg from "../assets/image/elemental 'e'.svg";
import { HomeContext } from "../containers/Home";
import { switchTenant } from "../utils/switchTenant";

interface TenantSwitchBoundaryProps {
	children: React.ReactNode;
	/** What belongs to the other tenant, in the switch prompt. */
	subject?: string;
}

function TenantSwitchBoundary({
	children,
	subject = "project",
}: TenantSwitchBoundaryProps) {
	const { currentTenantData, tenantData }: any = useContext(HomeContext);

	const location = useLocation();

	const fallbackComponent = (
		tenant_key: string | null,
		fallbackMessage: string | null = null
	) => {
		const handleTenantSwitch = () => {
			switchTenant(tenant_key ?? currentTenantData.role_key, () => {
				// clear the search params before reload
				window.history.replaceState({}, "", window.location.pathname);
				window.location.reload();
			});
		};

		return (
			<div className="no-access-container">
				<div className="hexlock-container">
					<div className="noaccess-icon">
						<Image
							preview={false}
							width={"185px"}
							className="home-logo no-visual-search"
							src={elementalSvg}
							alt="Logo"
						/>
					</div>
				</div>
				<span
					style={{
						fontSize: "20px",
						lineHeight: "30px",
						textAlign: "center",
						display: "flex",
						flexDirection: "column",
					}}
				>
					{fallbackMessage ? (
						<span>{fallbackMessage}</span>
					) : (
						<span>
							This {subject} belongs to another tenant. Would you like to{" "}
							<a onClick={handleTenantSwitch}>switch</a> to that tenant?
						</span>
					)}
				</span>
			</div>
		);
	};

	if (location.search) {
		const params = new URLSearchParams(location.search);
		const params_tenant_key = params.get("tenant_key");
		if (params_tenant_key && params_tenant_key !== currentTenantData.role_key) {
			const foundTenant = tenantData.find(
				(tenant: any) => tenant.role_key === params_tenant_key
			);
			if (!foundTenant) {
				const fallbackMessage = `You currently do not have access. Please contact the administrator for assistance`;
				return fallbackComponent(params_tenant_key, fallbackMessage);
			}
			return fallbackComponent(params_tenant_key);
		}
	}

	return <>{children}</>;
}

export default TenantSwitchBoundary;
